import React, { lazy, Suspense, useMemo } from 'react';
const CondensedMobileView = lazy(() => import('src/common/refactoredComponents/condensedMobileView/CondensedMobileView'));
import { AccountTitle } from './CondensedMobileView.styled';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import { HeaderContainer, Header, MainWrapper, ReservationMessageWrapper, ReservationMessageSpan, DontShipText, ItemContainer } from './CondensedMobileViewSets.styled';
import StorageRequest from 'src/assets/images/storage-request.svg';
import { SEMANTIC_TEXT_SMALL_PX, FONT_FAMILY_DEMI, DARK_NAVY_FONT_COLOR, WHITE_FONT_COLOR, LARGE_TEXT_PX, FONT_FAMILY_REGULAR, X_SMALL_TEXT_PX, TITLE_FONT_COLOR, SEMANTIC_TEXT_PX, GREY_PRODUCT_LIST_COLOR } from 'src/styles/fonts/MCFontConstants';
import { getTotalQuantity } from 'src/utils/util';


const CondensedMobileViewSets = ({
        setImplant,
        setInstrument,
        section,
        cartPage,
        isOrderDetailTab,
        t,
        marginSets,
        isCartScreenOrProductGuide,
        itemCardsContainerMinMobWidthSets,
        minWidthSets,
        isOrderScreen,
        reviewScreen,
        cartProducts,
        marginOnMobileDeviceSets,
        isShippingScreen,
        showCheckBox,
        marginOnMediumDeviceSets,
        shipDontShipSurgery,
        isCondensedView,
        implantShipAll,
        marginOnLargeDeviceSets,
        checkAll,
        checkSelectAllDisabled,
        countryISOCode,
        selectAllDisabled,
        handleShipAllChange,
        expandedProducts,
        expandedProductsItemList,
        toggleProduct,
        toggleProductItemList,
        isEquityTemp,
        orderType,
        handleSetItemClick,
        removeCounter,
        addCounter,
        setsQuantityCheck,
        products,
        handleLocationChange,
        checked,
        isBatchSelected,
        setIsBatchSelected,
        selectedLocation,
        deleteProduct,
        onBomClick,
        handleSetSelection,
        isReviewSubmitScreen,
        isTemplateDetail,
        isFromTemplates,
        instrumentShipAll,
        isSurgery,
        isConsignmentAdd,
        widthSets,
        marginRight,
        isQuickOrder = false,
        inventoryShipping = false,
    }) => {
    const implantItems = useMemo(() =>
        setImplant?.map((item, index) => (
            <ItemContainer key={index}>
                <Suspense fallback={<div>{t('common.loadingText')}</div>}>
                    <CondensedMobileView
                        isEquityTemplate={isEquityTemp}
                        orderType={orderType}
                        showCheckBox={showCheckBox}
                        isCartScreenOrProductGuide={isCartScreenOrProductGuide}
                        onToggle={() =>
                            isOrderScreen
                                ? isOrderDetailTab
                                    ? toggleProductItemList(item?.productKey)
                                    : toggleProduct(item?.productKey)
                                : toggleProduct(item?.productKey)
                        }
                        isExpanded={
                            isOrderScreen
                                ? isOrderDetailTab
                                    ? expandedProductsItemList?.has(item?.productKey)
                                    : expandedProducts?.has(item?.productKey)
                                : expandedProducts?.has(item?.productKey)
                        }
                        isShippingScreen={isShippingScreen}
                        isOrderDetailTab={isOrderDetailTab}
                        cartPage={cartPage}
                        isEquityTemp={isEquityTemp}
                        marginOnMediumDeviceSets={marginOnMediumDeviceSets}
                        marginOnLargeDeviceSets={marginOnLargeDeviceSets}
                        marginOnMobileDeviceSets={marginOnMobileDeviceSets}
                        key={`${item.cfn}-${0}`}
                        isCounterButton={true}
                        minWidthSets={minWidthSets}
                        setOrItemDetails={item}
                        removeCount={() =>
                            item.quantity > 0 &&
                            removeCounter(item?.productKey, item?.isSet, item)
                        }
                        addCount={() => addCounter(item)}
                        cardType={'items'}
                        count={products.count}
                        showBrand={true}
                        showType={true}
                        marginSets={marginSets}
                        setNameColor={TITLE_FONT_COLOR}
                        setNameFontSizeMobile={SEMANTIC_TEXT_PX}
                        setNameFontSizeDesktop={SEMANTIC_TEXT_PX}
                        itemCardsContainerMinMobWidthSets={itemCardsContainerMinMobWidthSets}
                        onSetItemClick={handleSetItemClick}
                        clickable={true}
                        basePrice={item?.basePrice}
                        extPrice={item?.extPrice}
                        productSearchFlag={true}
                        productType={'Cart'}
                        isCart={true}
                        setIsQuantityMoreThan50={true}
                        description={item.description}
                        background={index % 2 !== 0 ? GREY_PRODUCT_LIST_COLOR : ''}
                        inventoryShipping={inventoryShipping}
                        handleLocationChange={handleLocationChange}
                        checkAll={checkAll}
                        checked={checked}
                        checkSelectAllDisabled={checkSelectAllDisabled}
                        selectAllDisabled={selectAllDisabled}
                        handleShipAllChange={handleShipAllChange}
                        isBatchSelected={isBatchSelected}
                        setIsBatchSelected={setIsBatchSelected}
                        selectedLocation={selectedLocation}
                        section={section}
                        deleteProduct={deleteProduct}
                        onBomClick={onBomClick}
                        reviewScreen={reviewScreen}
                        handleSetSelection={handleSetSelection}
                        isReviewSubmitScreen={isReviewSubmitScreen}
                        isOrderScreen={isOrderScreen}
                        isTemplateDetail={isTemplateDetail}
                        isFromTemplates={isFromTemplates}
                        marginRight={marginRight}
                        isQuickOrder={isQuickOrder}
                    />
                </Suspense>
            </ItemContainer>
        ))
    , [setImplant, isEquityTemp, orderType, showCheckBox, isOrderScreen, isOrderDetailTab, expandedProductsItemList, expandedProducts, isShippingScreen, cartPage, marginOnMediumDeviceSets, marginOnLargeDeviceSets, marginOnMobileDeviceSets, minWidthSets, handleSetItemClick, removeCounter, addCounter, products, marginSets, itemCardsContainerMinMobWidthSets, checked, checkAll, checkSelectAllDisabled, selectAllDisabled, handleShipAllChange, isBatchSelected, setIsBatchSelected, selectedLocation, section, deleteProduct, onBomClick, reviewScreen, handleSetSelection, isReviewSubmitScreen, isTemplateDetail, isQuickOrder]);

    const instrumentItems = useMemo(() =>
        setInstrument?.map((item, index) => (
            <ItemContainer key={index}>
                <Suspense fallback={<div>{t('common.loadingText')}</div>}>
                    <CondensedMobileView
                        isEquityTemplate={isEquityTemp}
                        orderType={orderType}
                        showCheckBox={showCheckBox}
                        isCartScreenOrProductGuide={isCartScreenOrProductGuide}
                        onToggle={() =>
                            isOrderScreen
                                ? isOrderDetailTab
                                    ? toggleProductItemList(item?.productKey)
                                    : toggleProduct(item?.productKey)
                                : toggleProduct(item?.productKey)
                        }
                        isExpanded={
                            isOrderScreen
                                ? isOrderDetailTab
                                    ? expandedProductsItemList?.has(item?.productKey)
                                    : expandedProducts?.has(item?.productKey)
                                : expandedProducts?.has(item?.productKey)
                        }
                        isOrderDetailTab={isOrderDetailTab}
                        cartPage={cartPage}
                        isEquityTemp={isEquityTemp}
                        marginOnMediumDeviceSets={marginOnMediumDeviceSets}
                        marginOnLargeDeviceSets={marginOnLargeDeviceSets}
                        marginOnMobileDeviceSets={marginOnMobileDeviceSets}
                        key={`${item.cfn}-${0}`}
                        isCounterButton={true}
                        minWidthSets={minWidthSets}
                        setOrItemDetails={item}
                        removeCount={() =>
                            item.quantity > 0 &&
                            removeCounter(item?.productKey, item?.isSet, item)
                        }
                        addCount={() => setsQuantityCheck(item) && addCounter(item)}
                        cardType={'items'}
                        count={products.count}
                        showBrand={true}
                        showType={true}
                        marginSets={marginSets}
                        setNameColor={TITLE_FONT_COLOR}
                        setNameFontSizeMobile={SEMANTIC_TEXT_PX}
                        setNameFontSizeDesktop={SEMANTIC_TEXT_PX}
                        itemCardsContainerMinMobWidthSets={itemCardsContainerMinMobWidthSets}
                        onSetItemClick={handleSetItemClick}
                        clickable={true}
                        basePrice={item?.basePrice}
                        extPrice={item?.extPrice}
                        productSearchFlag={true}
                        productType={'Cart'}
                        isCart={true}
                        setIsQuantityMoreThan50={true}
                        description={item.description}
                        background={index % 2 !== 0 ? GREY_PRODUCT_LIST_COLOR : ''}
                        isShippingScreen={isShippingScreen}
                        inventoryShipping={inventoryShipping}
                        handleLocationChange={handleLocationChange}
                        checkAll={checkAll}
                        checked={checked}
                        checkSelectAllDisabled={checkSelectAllDisabled}
                        selectAllDisabled={selectAllDisabled}
                        handleShipAllChange={handleShipAllChange}
                        isBatchSelected={isBatchSelected}
                        setIsBatchSelected={setIsBatchSelected}
                        selectedLocation={selectedLocation}
                        section={section}
                        deleteProduct={deleteProduct}
                        onBomClick={onBomClick}
                        isEquity={isEquityTemp}
                        isTemplateDetail={isTemplateDetail}
                        isFromTemplates={isFromTemplates}
                        isFromSurgeryTemplate={false}
                        isSurgery={isSurgery}
                        isConsignmentAdd={isConsignmentAdd}
                        reviewScreen={reviewScreen}
                        handleSetSelection={handleSetSelection}
                        isReviewSubmitScreen={isReviewSubmitScreen}
                        isOrderScreen={isOrderScreen}
                        marginRight={marginRight}
                        isQuickOrder={isQuickOrder}
                    />
                </Suspense>
            </ItemContainer>
        ))
    , [setInstrument, isEquityTemp, orderType, showCheckBox, isOrderScreen, isOrderDetailTab, expandedProductsItemList, expandedProducts, cartPage, marginOnMediumDeviceSets, marginOnLargeDeviceSets, marginOnMobileDeviceSets, minWidthSets, handleSetItemClick, removeCounter, addCounter, setsQuantityCheck, products, marginSets, itemCardsContainerMinMobWidthSets, checked, checkAll, checkSelectAllDisabled, selectAllDisabled, handleShipAllChange, isBatchSelected, setIsBatchSelected, selectedLocation, section, deleteProduct, onBomClick, reviewScreen, handleSetSelection, isReviewSubmitScreen, isTemplateDetail, isSurgery, isConsignmentAdd, isQuickOrder]);

    return (
        <MainWrapper id="setItemDetails-mainWrapper" data-testid="setItemDetails-mainWrapper">
            {(setImplant?.length > 0 || setInstrument?.length > 0) &&
                !(section == 'template') &&
                !cartPage &&
                !isOrderDetailTab && (
                    <AccountTitle
                        backgroundColor={WHITE_FONT_COLOR}
                        fontSize={LARGE_TEXT_PX}
                        widthSets={widthSets}
                        data-testid="sets-account-title"
                    >
                        {t('common.setsPascalCaseLabel')} (
                        {isOrderScreen
                            ? setImplant?.filter(
                                  (d) =>
                                      d?.status !== 'キャンセル' &&
                                      d?.status?.toLowerCase() !== 'cancel'
                              )?.length +
                              setInstrument?.filter(
                                  (d) =>
                                      d?.status !== 'キャンセル' &&
                                      d?.status?.toLowerCase() !== 'cancel'
                              )?.length
                            : setImplant.length + setInstrument.length}
                        )
                        {reviewScreen && (
                            <React.Fragment>
                                {' '}
                                <ReservationMessageWrapper fontSize={SEMANTIC_TEXT_SMALL_PX}>
                                    {' '}
                                    {cartProducts.some(
                                        (product) => product.isReservationSet
                                    ) && (
                                        <>
                                            {' '}
                                            <img
                                                width="20px"
                                                src={StorageRequest}
                                            />{' '}
                                            &nbsp;{' '}
                                            <ReservationMessageSpan data-testid="reservation-required-message">
                                                {' '}
                                                {t('common.reservationRequired')}
                                            </ReservationMessageSpan>
                                        </>
                                    )}
                                </ReservationMessageWrapper>
                            </React.Fragment>
                        )}
                    </AccountTitle>
                )}
            {setImplant?.length > 0 && (
                <HeaderContainer data-testid="implants-header-container" marginTop={section === 'template' ? '10px' : undefined}>
                    <Header
                        data-testid="implants-header"
                    >
                        {t('common.implants')} (
                        {isOrderScreen
                            ? getTotalQuantity(
                                  setImplant.filter(
                                      (d) =>
                                          d?.status !== 'キャンセル' &&
                                          d?.status?.toLowerCase() !== 'cancel'
                                  )
                              )
                            : getTotalQuantity(setImplant)}
                        )
                    </Header>
                    {isShippingScreen &&
                        showCheckBox &&
                        shipDontShipSurgery !== 'NOT_VISIBLE' && (
                            <>
                                <DontShipText fontFamily={FONT_FAMILY_REGULAR} fontSize={X_SMALL_TEXT_PX}>
                                    {t('common.dontShip')}
                                </DontShipText>
                                <Checkbox
                                    checked={
                                        isCondensedView
                                            ? !implantShipAll &&
                                              setImplant
                                                  .filter(
                                                      (item) =>
                                                          !item.isReservationSet
                                                  )
                                                  .every(
                                                      (item) =>
                                                          !item.shippingRequirement
                                                  )
                                            : checkAll
                                    }
                                    label={''}
                                    onCheckboxSelectionChange={() =>
                                        handleShipAllChange('implant')
                                    }
                                    disabled={
                                        checkSelectAllDisabled(
                                            setImplant,
                                            countryISOCode
                                        ) || selectAllDisabled
                                    }
                                    id="common-CondensedMobileViewList-implant-checkbox"
                                    margin={'7px 15px 0 0'}
                                    labelStyleObj={{
                                        fontSize: SEMANTIC_TEXT_SMALL_PX,
                                        fontFamily: FONT_FAMILY_DEMI,
                                        color: DARK_NAVY_FONT_COLOR,
                                    }}
                                    background={'none'}
                                    checkboxBorder={'1.5px solid #555555'}
                                    alignItemDirection={'center'}
                                    hoverEffect={'false'}
                                    disableFocusEffect={'true'}
                                />
                            </>
                        )}
                </HeaderContainer>
            )}
            {implantItems}
            {setInstrument?.length > 0 && (
                <HeaderContainer data-testid="instruments-header-container">
                    <Header
                        data-testid="instruments-header"
                    >
                        {t('common.instruments')} (
                        {isOrderScreen
                            ? getTotalQuantity(
                                  setInstrument?.filter(
                                      (d) =>
                                          d?.status !== 'キャンセル' &&
                                          d?.status?.toLowerCase() !== 'cancel'
                                  )
                              )
                            : getTotalQuantity(setInstrument)}
                        )
                    </Header>
                    {isShippingScreen && showCheckBox && shipDontShipSurgery !== 'NOT_VISIBLE' && (
                        <>
                            <DontShipText>
                                {t('common.dontShip')}
                            </DontShipText>
                            <Checkbox
                                margin={'5px 15px 0 0' }
                                checked={
                                    isCondensedView
                                        ? !instrumentShipAll &&
                                          setInstrument
                                              .filter((item) => !item.isReservationSet)
                                              .every((item) => !item.shippingRequirement)
                                        : checkAll
                                }
                                label={''}
                                onCheckboxSelectionChange={() => handleShipAllChange('instrument')}
                                disabled={
                                    checkSelectAllDisabled(setInstrument, countryISOCode) || selectAllDisabled
                                }
                                id="common-CondensedMobileViewList-instrument-checkbox"
                                // margin={isSurgery ? '0 23px 0 0' : '0 15px 0 0'}
                                labelStyleObj={{
                                    fontSize: SEMANTIC_TEXT_SMALL_PX,
                                    fontFamily: FONT_FAMILY_DEMI,
                                    color: DARK_NAVY_FONT_COLOR,
                                }}
                                background={'none'}
                                checkboxBorder={'1.5px solid #555555'}
                                alignItemDirection={'center'}
                                hoverEffect={'false'}
                                disableFocusEffect={'true'}
                            />
                        </>
                    )}
                </HeaderContainer>
            )}
            {instrumentItems}
        </MainWrapper>
    );
};

export default CondensedMobileViewSets;
